import React from 'react';

export const ParsonsContext = React.createContext({
  updateTab: () => {
  },
  language: 'python',
});